import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'

const Sobre = (props) => {
	const { id } = props;
	const getImagenes = graphql`
	{
		webhook:file(relativePath: {eq: "webhook.png"}) {
			childImageSharp {
				fluid(maxWidth: 220) {
					...GatsbyImageSharpFluid
				}
			}
		}
		extension:file(relativePath: {eq: "extension.png"}) {
			childImageSharp {
				fluid(maxWidth: 220) {
					...GatsbyImageSharpFluid
				}
			}
		}
		saas:file(relativePath: {eq: "saas.png"}) {
			childImageSharp {
				fluid(maxWidth: 220) {
					...GatsbyImageSharpFluid
				}
			}
		}

	}`
	const data = useStaticQuery(getImagenes);
	const { webhook, extension, saas } = data;

	return (

		<section className="page-section" >
			<div className="name-section" id={id}>
				<Container>
					<h2 className="text-center mt-0 title-general">¿Qué es Desarrollo a medida?</h2>
					<hr className="divider my-4" />
					<Row className="mb-5">
						<Col md={{ span: 8, offset: 2 }}>
							<p className="text-center">
								Nuestro servicio de desarrollo a medida está orientado a cubrir las necesidades de software de grandes empresas. Desde potenciar tu ERP con la integración de nuestras soluciones, hasta desarrollar servicios bajo la modalidad ‘Software as a Service’ (SaaS), cuéntanos sobre tu proyecto y deja que un equipo de profesionales integral se encargue de su desarrollo y mantención.”
							</p>
						</Col>
					</Row>
					<Row className="m-5">
						<Col>
							<h4 className="text-center mt-4 text-primary">¡DESARROLLAMOS LO QUE NECESITAS!</h4>
						</Col>
					</Row>

					<Row>
						<Col md={4} sm={12} className="mb-3">
							<div className="mr-1 ml-1 caja">
								<div className="img-ser">
									<Image fluid={webhook.childImageSharp.fluid} />
								</div>
								<div className="text-center titulo">
									WebHook’s y API’s
								</div>
								<p className="text-center">
									Mejoramos el funcionamiento de tu aplicación web mediante callbacks personalizados y API’s REST.
								</p>
							</div>
						</Col>
						<Col md={4} sm={12} className="mb-3">
							<div className="mr-1 ml-1 caja">
								<div className="img-ser">
									<Image fluid={extension.childImageSharp.fluid} />
								</div>
								<div className="text-center titulo">
									Extensiones Chrome
								</div>
								<p className="text-center">
									Añadimos nuevas funciones y servicios directamente en tu navegador.
								</p>
							</div>
						</Col>
						<Col md={4} sm={12} className="mb-3">
							<div className="mr-1 ml-1 caja">
								<div className="img-ser">
									<Image fluid={saas.childImageSharp.fluid} />
								</div>
								<div className="text-center titulo">
									Software as a Service
								</div>
								<p className="text-center">
									Creamos tus proyectos para que no te preocupes de su desarrollo o mantención.
								</p>
							</div>
						</Col>
					</Row>



				</Container>
			</div>
		</section>
	)
}

export default Sobre
